import { store } from "../store";
import { AgeRestricted } from "../types/age-restriction";
import { UtilsDateTime } from "./UtilsDateTIme";
import { HubRegions } from "../data/landing-page";
import { UtilsLocale } from "./UtilsLocale";
import { ERegions } from "../types/landing-page";
import { USER_TYPE_CODE } from "../types/user";

export const REQUEST_RESTRICTED_13_COUNTRIES = ["USA"];
export const REQUEST_RESTRICTED_14_COUNTRIES = ["KOR"];

export const MENA_AGE_RESTRICTED: AgeRestricted[] = [
  { countryCode: "BHR", age: 13 }, // Bahrain - Added Oct 2025
  { countryCode: "ARE", age: 13 }, // United Arab Emirates - Added Oct 2025
  { countryCode: "EGY", age: 14 }, // Egypt - Added Oct 2025
  { countryCode: "DZA", age: 13 }, // Algeria - Added Oct 2025
  { countryCode: "YEM", age: 13 }, // Yemen - Added Oct 2025
  { countryCode: "TUN", age: 13 }, // Tunisia - Added Oct 2025
  { countryCode: "SAU", age: 13 }, // Saudi Arabia - Added Oct 2025
  { countryCode: "QAT", age: 13 }, // Qatar - Added Oct 2025
  { countryCode: "PAK", age: 13 }, // Pakistan - Added Oct 2025
  { countryCode: "MAR", age: 13 }, // Morocco - Added Oct 2025
  { countryCode: "LBN", age: 13 }, // Lebanon - Added Oct 2025
  { countryCode: "KWT", age: 13 }, // Kuwait - Added Oct 2025
  { countryCode: "JOR", age: 13 }, // Jordan - Added Oct 2025
  { countryCode: "IRQ", age: 13 }, // Iraq - Added Oct 2025
];

export const EU_AGE_RESTRICTED: AgeRestricted[] = [
  { countryCode: "ALB", age: 18 }, // Albania - Added Oct 2025
  { countryCode: "AND", age: 16 }, // Andorra - Updated Oct 2025
  // { countryCode: "AUT", age: 14 }, // Austria - Removed Oct 2025
  { countryCode: "BEL", age: 13 }, // Belgium
  { countryCode: "BIH", age: 13 }, // Bosnia and Herzegovina - Updated Oct 2025
  { countryCode: "BGR", age: 14 }, // Bulgaria - Updated Oct 2025
  { countryCode: "HRV", age: 16 }, // Croatia - Updated Oct 2025
  { countryCode: "CYP", age: 14 }, // Cyprus - Updated Oct 2025
  { countryCode: "CZE", age: 15 }, // Czechia - Updated Oct 2025
  { countryCode: "DNK", age: 15 }, // Denmark - Updated Oct 2025
  // { countryCode: "EST", age: 13 }, // Estonia - Removed Oct 2025
  // { countryCode: "FRO", age: 13 }, // Faroe Islands - Removed Oct 2025
  { countryCode: "FIN", age: 13 }, // Finland - Updated Oct 2025
  { countryCode: "FRA", age: 18 }, // France - Updated Oct 2025
  { countryCode: "DEU", age: 16 }, // Germany - Updated Oct 2025
  // { countryCode: "GIB", age: 14 }, // Gibraltar - Removed Oct 2025
  { countryCode: "GRC", age: 15 }, // Greece - Updated Oct 2025
  // { countryCode: "GRL", age: 15 }, // Greenland - Removed Oct 2025
  // { countryCode: "VAT", age: 13 }, // Holy See - Removed Oct 2025
  { countryCode: "HUN", age: 16 }, // Hungary - Updated Oct 2025
  { countryCode: "ISL", age: 13 }, // Iceland - Updated Oct 2025
  { countryCode: "ITA", age: 14 }, // Italy - Updated Oct 2025
  { countryCode: "XKX", age: 16 }, // Kosovo - Updated Oct 2025
  // { countryCode: "IRL", age: 16 }, // Ireland - Removed Oct 2025
  // { countryCode: "LVA", age: 13 }, // Latvia - Removed Oct 2025
  // { countryCode: "LIE", age: 16 }, // Liechtenstein - Removed Oct 2025
  // { countryCode: "LTU", age: 14 }, // Lithuania - Removed Oct 2025
  { countryCode: "LUX", age: 16 }, // Luxembourg - Updated Oct 2025
  // { countryCode: "MLT", age: 13 }, // Malta - Removed Oct 2025
  // { countryCode: "MCO", age: 16 }, // Monaco - Removed Oct 2025
  { countryCode: "MNE", age: 18 }, // Montenegro - Updated Oct 2025
  { countryCode: "NLD", age: 16 }, // Netherlands - Updated Oct 2025
  { countryCode: "MKD", age: 14 }, // (North)Macedonia - Updated Oct 2025
  { countryCode: "NOR", age: 15 }, // Norway - Updated Oct 2025
  { countryCode: "POL", age: 16 }, // Poland - Updated Oct 2025
  { countryCode: "PRT", age: 13 }, // Portugal - Updated Oct 2025
  { countryCode: "ROU", age: 16 }, // Romania - Updated Oct 2025
  // { countryCode: "SMR", age: 16 }, // San Marino - Removed Oct 2025
  { countryCode: "SRB", age: 15 }, // Serbia
  { countryCode: "SVK", age: 16 }, // Slovakia - Updated Oct 2025
  { countryCode: "SVN", age: 16 }, // Slovenia - Updated Oct 2025
  { countryCode: "ESP", age: 14 }, // Spain - Updated Oct 2025
  { countryCode: "SWE", age: 16 }, // Sweden - Updated Oct 2025
  { countryCode: "CHE", age: 16 }, // Switzerland - Updated Oct 2025
  { countryCode: "GBR", age: 13 }, // United Kingdom - Updated Oct 2025
];

export const UtilsUser = {
  isUserLoggedIn: () => {
    return store.getState().auth.isLoggedIn;
  },

  isUserRestricted: (
    countryCode: string,
    userBirthdate: string,
    userTypeCode: USER_TYPE_CODE,
    sysPropAge?: number,
    isEU = false,
    isMENA = false
  ) => {
    const isSAChildAccount = userTypeCode === USER_TYPE_CODE.CHILD;
    const isSADefaultAccount = userTypeCode === USER_TYPE_CODE.INDIVIDUAL;
    const isKorea = REQUEST_RESTRICTED_14_COUNTRIES.indexOf(countryCode) != -1;
    const userAge = sysPropAge || UtilsUser.getUserAge(userBirthdate);
    // if default account and from korea
    if (isKorea && isSADefaultAccount) {
      if (userAge < 14) return true;
    }
    // If not a child account, no restrictions apply
    if (!isSAChildAccount) {
      return false;
    }
    // If child account, check restrictions
    if (REQUEST_RESTRICTED_13_COUNTRIES.indexOf(countryCode) >= 0) {
      if (userAge < 13) return true; // 12 Below
    }

    if (isKorea) {
      if (userAge < 14) return true; // 13 Below
    }

    if (isEU) {
      const ageRestriction = EU_AGE_RESTRICTED.filter(
        (data) => data.countryCode === countryCode
      );

      if (ageRestriction.length > 0) {
        return userAge < ageRestriction[0].age; // age below restriction age value
      }
    }

    if (isMENA) {
      const ageRestriction = MENA_AGE_RESTRICTED.filter(
        (data) => data.countryCode === countryCode
      );

      if (ageRestriction.length > 0) {
        return userAge < ageRestriction[0].age; // age below restriction age value
      }
    }

    return false;
  },

  getUserAge: (date: string) => {
    const now = new Date();
    let birthDate = UtilsDateTime.parseDate(date, true);

    // get time diff
    let diff = (now.getTime() - birthDate.getTime()) / 1000;

    // get diff in years for age
    diff = Math.floor(diff / (365.25 * 24 * 60 * 60));

    return diff;
  },
  isEmailLogin: () => {
    return store.getState().auth.type === "EMAIL";
  },

  getMENALocalSiteLink: (countryCode: string) => {
    // Check if the country is in MENA age restricted list
    const isMENACountry = MENA_AGE_RESTRICTED.some(
      (country) => country.countryCode === countryCode
    );

    if (!isMENACountry) {
      return null;
    }

    // Find the MENA region in HubRegions
    const menaRegion = HubRegions.find(
      (region) => region.code === ERegions.MENA
    );
    if (!menaRegion) {
      return null;
    }

    // Find the country in MENA region
    const saCountry = UtilsLocale.convertISO3toISO2(countryCode);
    const country = menaRegion.countries.find((c) => c.code === saCountry);

    return country?.link || null;
  },
};
